import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between bg-white w-full border-b-2 border-gray-200" }
const _hoisted_2 = { class: "flex flex-initial flex-nowrap items-center space-x-2" }
const _hoisted_3 = { class: "flex-1 flex flex-col flex-nowrap justify-between min-h-full mr-2" }
const _hoisted_4 = { class: "font-semibold text-left text-[75%] inline-block min-w-min naming-span" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-light text-gray-500 grow-0 flex-1 text-clip text-[60%]" }, "Atribuído: ", -1)
const _hoisted_6 = { class: "text-left flex-1 text-clip text-[70%]" }
const _hoisted_7 = { class: "flex items-center mr-2" }

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { CircleCheck, CircleUserRound, ChevronLeft } from 'lucide-vue-next';
import { PropType, computed } from 'vue';
import { useRouter } from 'vue-router';
import { Customer, CustomerSession } from '@/http/customerSession';
import { Button } from '@/components/ui/button';
import { finishSession } from '@/http/customerSession';
import { useStore } from 'vuex';
import Dialog from '@/components/ui/dialog/Dialog.vue';
import DialogTrigger from '@/components/ui/dialog/DialogTrigger.vue';
import DialogContent from '@/components/ui/dialog/DialogContent.vue';
import DialogHeader from '@/components/ui/dialog/DialogHeader.vue';
import DialogTitle from '@/components/ui/dialog/DialogTitle.vue';
import DialogDescription from '@/components/ui/dialog/DialogDescription.vue';
import DialogFooter from '@/components/ui/dialog/DialogFooter.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConverzaSessionsHeader',
  props: {
    customerSession: {
        type: Object as PropType<CustomerSession | undefined>,
        required: false,
    },
    updatedCustomerName: {
        type: String as PropType<string | undefined>,
        required: false,
    }
},
  emits: ['TOGGLE_CUSTOMER_SIDEBAR'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const customer = computed<Customer | undefined>(() => {
    return props.customerSession?.customer;
});

const store = useStore();
const requestSessionFinishment = async () => {
    if (props?.customerSession?.id === undefined) { return; }
    await finishSession(props.customerSession.id, store.state.credentials);
    return;
};

const router = useRouter();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ChevronLeft), {
        class: "mr-2",
        onClick: _cache[0] || (_cache[0] = () => _unref(router).push({ path: '/dashboard/atendimento' }))
      }),
      _createVNode(_unref(Avatar), {
        shape: "circle",
        size: "icon-larger",
        class: "flex-initial"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AvatarImage), {
            src: "https://github.com/radix-vue.png",
            alt: "@radix-vue"
          }),
          _createVNode(_unref(AvatarFallback), null, {
            default: _withCtx(() => [
              _createTextVNode("CN")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.updatedCustomerName ?? customer.value?.partnerAttributes.name ?? customer.value?.key ?? ''), 1),
        _createElementVNode("div", {
          class: _normalizeClass([{ hidden: !__props.customerSession?.whoIsChatting }, "flex flex-row items-center min-w-min"])
        }, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, " " + _toDisplayString(__props.customerSession?.nameOfWhoIsChatting ?? __props.customerSession?.whoIsChatting), 1)
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (__props.customerSession?.status !== 'FINISHED')
        ? (_openBlock(), _createBlock(Dialog, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(DialogTrigger, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    class: "px-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CircleCheck))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DialogContent, null, {
                default: _withCtx(() => [
                  _createVNode(DialogHeader, null, {
                    default: _withCtx(() => [
                      _createVNode(DialogTitle, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Encerrar a Sessão?")
                        ]),
                        _: 1
                      }),
                      _createVNode(DialogDescription, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" Esta sessão será encerrada. Você ainda poderá ler, mas o usuário precisará iniciar outra sessão para manter contato. ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DialogFooter, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Button), {
                        variant: "destructive",
                        onClick: requestSessionFinishment
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Encerrar ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(Button), {
        variant: "ghost",
        size: "icon",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('TOGGLE_CUSTOMER_SIDEBAR')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(CircleUserRound))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})